export const SET_USER_AUTH_INFO = 'SET_USER_AUTH_INFO'
export const SET_USER_AUTH_INFO_PENDING = 'SET_USER_AUTH_INFO_PENDING'
export const SET_USER_AUTH_INFO_FULFILLED = 'SET_USER_AUTH_INFO_FULFILLED'
export const SET_USER_AUTH_INFO_REJECTED = 'SET_USER_AUTH_INFO_REJECTED'
